export default "__VITE_ASSET__EFgvtqSv__"